export default {
  'SAVE_COMPANIES' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_COMPANIES' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/mutations.js